import React, { useState } from "react";
import ReactDOMServer from "react-dom/server";
import * as Dialog from "@radix-ui/react-dialog";

import styled from "styled-components";
import { Button } from "./ui/button";
import { Cross2Icon } from "@radix-ui/react-icons";
import StatementDocument from "./StatementDocument";
import { buildSection } from "../../helpers/statement";
import { walletChoices } from "../Statements/index";

const TransferStatement = ({
  open,
  handleClose,
  transactions,
  userData,
}: {
  open: boolean;
  handleClose: () => void;
  transactions: any[];
  userData: any;
}) => {
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");

  const handlePrint = () => {
    const newWindow = window.open("", "_blank");
    newWindow?.document.write(`
      <html>
        <head>
          <title>Invoice</title>
          <style>
            body { font-family: Arial, sans-serif; }
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid #ddd; padding: 8px; }
            th { background-color: #f2f2f2; }
          </style>
        </head>
        <body>
         ${ReactDOMServer.renderToStaticMarkup(
           <StatementDocument
             startDate={startDate}
             endDate={endDate}
             sections={walletChoices(userData?.wallets).map((choice) =>
               buildSection({
                 currencyCode: choice.code,
                 walletNumber: choice.walletNumber,
                 currentBalance: choice.balance,
                 // Only what this screen has loaded. The Statements page
                 // fetches the full range; this dialog is the older path.
                 transactions: transactions.filter(
                   (t) => String(t.currency_code ?? "").toUpperCase() === choice.code,
                 ),
                 startDate,
                 endDate,
               }),
             )}
             userData={userData}
           />,
         )}
      </body>
      </html>
    `);
    newWindow?.document.close();
    newWindow?.print();
  };

  return (
    <Dialog.Root open={open}>
      <Dialog.Portal>
        <Dialog.Overlay className="DialogOverlay" />
        <DialogContent className="DialogContentSmall">
          <Dialog.Title className="DialogTitle">Transfer Statement</Dialog.Title>

          <Dialog.Description className="DialogDescription">
            Select dates to print out your bank statement
          </Dialog.Description>

          <div className="flex w-full flex-col space-y-4">
            <div className="flex w-full flex-col space-y-2">
              <label>From</label>
              <input
                type="date"
                value={startDate}
                onChange={(e) => {
                  const selectedStartDate = e.target.value;
                  if (endDate && new Date(selectedStartDate) > new Date(endDate)) {
                    setEndDate("");
                  }
                  setStartDate(selectedStartDate);
                }}
                className="border border-slate-200 p-2 outline-red-500"
                max={new Date().toISOString().split("T")[0]}
              />
            </div>
            <div className="flex w-full flex-col space-y-2">
              <label>To</label>
              <input
                type="date"
                value={endDate}
                onChange={(e) => {
                  const selectedEndDate = e.target.value;
                  if (startDate && new Date(selectedEndDate) < new Date(startDate)) {
                    setStartDate("");
                  }
                  setEndDate(selectedEndDate);
                }}
                className="border border-slate-200 p-2 outline-red-500"
                max={new Date().toISOString().split("T")[0]}
              />
            </div>
          </div>

          <div style={{ display: "flex", marginTop: 25, justifyContent: "flex-end" }}>
            <Dialog.Close asChild>
              <StyledButton
                onClick={handlePrint}
                type="button"
                className="flex items-center justify-center py-2 rounded-md bg-red-500 px-6 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-400"
              >
                Print
              </StyledButton>
            </Dialog.Close>
          </div>
          <Dialog.Close asChild>
            <CloseIconButton onClick={handleClose} className="IconButton" aria-label="Close">
              <Cross2Icon width="20" height="20" />
            </CloseIconButton>
          </Dialog.Close>
        </DialogContent>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

const CloseIconButton = styled.button`
  @media print {
    display: none;
  }
`;

const StyledButton = styled(Button)`
  @media print {
    display: none;
  }
`;

const DialogContent = styled(Dialog.Content)`
  @media print {
    width: 100vw;
    heigt: 100vh;
  }
`;

export default TransferStatement;
